const Loading = () => {
  return (
    <div className='loading'>
            <img src="/assets/images/others/loading_summer.gif?v=20250511"></img>
    </div>
  )
}
export default Loading